export function toI18nKeySegment(value: string): string {
  return value.replace(/[.:/-]+/g, '_');
}
